import { BlockComponentFactory } from 'shared/express-interface/blocks-core/BlockFactory'

type TextBlockProps = {
    text: string
}

export const TextBlockComponent = BlockComponentFactory.createBlockComponent<TextBlockProps>(
    props => {
        return <p style={props.style}>{props.text}</p>
    }
)
